/**
 * The text horizontal growth data attribute, Will have one of the TEXT_HORIZONTAL_GROW values below.
 * @type {String}
 */
const TEXT_HORIZONTAL_GROW_ATTRIBUTE = 'data-horizontal-grow';

/**
 * The possible text growth directions.
 */
const TEXT_HORIZONTAL_GROW = {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right'
};

module.exports = {
    TEXT_HORIZONTAL_GROW_ATTRIBUTE,
    TEXT_HORIZONTAL_GROW
};
